import DrawerLib from 'react-bottom-drawer';
import { createPortal } from 'react-dom';

import { Icon } from '../Icon';
import styles from './Drawer.module.scss';

interface DrawerProps {
  open: boolean;
  onClose: () => void;
  children: React.ReactNode;
}

export const Drawer: React.FC<DrawerProps> = ({ open, onClose, children }) => {
  const drawerNode = (
    <>
      {open && <div className="rbDrawerBackdrop" onClick={onClose} />}{' '}
      <DrawerLib
        isVisible={open}
        onClose={onClose}
        className={`rbDrawer ${styles.drawer}`}
      >
        <button type="button" className={styles.closeButton} onClick={onClose}>
          <Icon
            className={styles.closeIcon}
            name="outlinedCancel"
            width={12}
            height={12}
          />
        </button>
        {children}
      </DrawerLib>
    </>
  );

  return createPortal(drawerNode, document.body);
};
